exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".related-fares-list[data-v-7d45f8b2]{background-color:#f0f0f0;height:100%}.related-fares-list-container[data-v-7d45f8b2]{width:90%;padding-top:80px;position:relative}.btn-back[data-v-7d45f8b2]{position:absolute;left:12px;top:20px}", ""]);

// exports
